<div class="container-fluid h-100 position-fixed p-0">
<div class="d-flex flex-row justify-content-center">
  <div class="col-md-4 p-5 bg-white">
    <ng-content></ng-content>
  </div>
</div>
</div>



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/layout/components/layout-auth-container/layout-auth-container.component.html